export default __webpack_public_path__ + "static/media/IMG_8679.ee16690a.JPG";